import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import ModuleContainer from '@/presentation/components/Container';
import { SubsectionHeader } from '@/presentation/reusables/SectionHeader';
import RenderContentExamRol from './components/RenderContent';
import DateHelpers from '@/core/helpers/DateHelper';

interface IExamRolProps {
  isLoadingData?: boolean;
  hasError?: boolean;
  dataExamRol?: any;
  handlerBack: any;
}

const ExamRolViewNew = ({
  isLoadingData,
  handlerBack,
  dataExamRol,
  hasError
}: IExamRolProps) => {
  const [isLoadData, setIsLoadData] = useState(true);
  const { current_utp_period: currentPeriod } = useSelector(
    (state: any) => state?.externalSettings?.data
  );

  useEffect(() => {
    setIsLoadData(isLoadingData ?? false);
  }, [isLoadingData, dataExamRol]);

  return (
    <ModuleContainer containerType="section">
      <SubsectionHeader
        onClick={handlerBack}
        title="Rol de exámenes"
        style={{ padding: '16px 0px' }}
        description={
          <>
            Revisa la programación de tus exámenes finales del ciclo{' '}
            <b>{DateHelpers.periodToName2(currentPeriod)}</b>. Si tienes
            exámenes rezagados o devoluciones, también se mostrarán aquí.
          </>
        }
      />
      <RenderContentExamRol
        isLoading={isLoadData}
        hasError={hasError}
        dataExamRol={dataExamRol ?? {}}
      />
    </ModuleContainer>
  );
};

export default ExamRolViewNew;
